class EventsRenderer extends HTMLElement {
  constructor() {
    super();
    this.templateId = this.getAttribute('template-id') || 'eventTemplate';
    this.boundHandleNewEvent = this.handleNewEvent.bind(this);
    this.boundResetEvents = this.resetEvents.bind(this);
  }

  connectedCallback() {
    this.render();
    this.loader = this.closest('events-loader');
    if (!this.loader) {
      console.error('EventsRenderer must be a child of EventsLoader');
      return;
    }
    this.setupEventListeners();
  }

  render() {
    // Keep the existing content (including the server-rendered slot)
    const existingContent = this.innerHTML;
    this.innerHTML = `
      <div class="layout-grid-container-3col">
        <div class="layout-grid events-container">
          ${existingContent}
        </div>
      </div>
    `;
  }

  setupEventListeners() {
    this.loader.addEventListener('new-event', this.boundHandleNewEvent);
    this.loader.addEventListener('reset-events', this.boundResetEvents);
  }

  disconnectedCallback() {
    if (this.loader) {
      this.loader.removeEventListener('new-event', this.boundHandleNewEvent);
      this.loader.removeEventListener('reset-events', this.boundResetEvents);
    }
  }

  handleNewEvent(event) {
    const eventData = event.detail;
    const template = document.getElementById(this.templateId);
    if (!template) {
      console.error(`Template with id "${this.templateId}" not found`);
      return;
    }
    const eventElement = this.createEventElement(template, eventData);
    this.querySelector('.events-container').appendChild(eventElement);
  }

  resetEvents() {
    const container = this.querySelector('.events-container');
    container.innerHTML = '';
  }

  createEventElement(template, eventData) {
    const element = template.content.cloneNode(true);

    const headline = element.querySelector('[name="headline"]');
    if (headline?.parentElement) {
      headline.parentElement.innerHTML = eventData.abstract;
    }

    const link = element.querySelector('[name="link"]');
    if (link) {
      link.href = eventData.event_uri;
    }

    const eventDate = element.querySelector('[name="event-date"]');
    if (eventDate && eventData.inputdate) {
      const date = new Date(eventData.inputdate * 1000);
      const locale = navigator.language || 'de-DE';
      eventDate.textContent = date.toLocaleDateString(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });

      if(eventData.additionaleventinformation) {
        const separator = ' | '
        eventDate.textContent = eventDate.textContent + separator;
      }
    }

    const eventType = element.querySelector('[name="event-type"]');
    if (eventType) {
      eventType.textContent = eventData.additionaleventinformation;
    }

    const imageElement = element.querySelector('[name="image"]');
    if (eventData.files?.url && imageElement) {
      imageElement.src = eventData.files.url;
      imageElement.alt = eventData.abstract;
    }

    return element.firstElementChild;
  }
}

customElements.define('events-renderer', EventsRenderer);
